import { render } from "./loader-comp.vue?vue&type=template&id=4853f52d&scoped=true"
import script from "./loader-comp.vue?vue&type=script&lang=js"
export * from "./loader-comp.vue?vue&type=script&lang=js"

import "./loader-comp.vue?vue&type=style&index=0&id=4853f52d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4853f52d"]])

export default __exports__